module.exports = __webpack_public_path__ + "img/template-icon-dark.84eed4a6.svg";